export var SnackBarProgressMode;
(function (SnackBarProgressMode) {
    SnackBarProgressMode["LINE"] = "line";
    SnackBarProgressMode["TIMER"] = "timer";
})(SnackBarProgressMode || (SnackBarProgressMode = {}));
